module.exports = __webpack_public_path__ + "resources/img/img_spiceware_one_01.9a969ced85c11d2691744abc3a2fa53a.png";